export default {
  message: {
    "error": "Сталася помилка!",
    "Sorrysomeerrorsoccurred": "Вибачте, сталася одна або кілька помилок",
    "quit": "Вийти",
    "language": "Мова",
    "Youcanchangethelanguagehere": "Ви можете змінити мову тут!",
    "current": "Поточна",
    "home": "Головна",
    "friends": "Друзі",
    "wallet": "Гаманець",
    "aboutus": "Про нас",
    "Sharewithfriends": "Поділитися з друзями",
    "copyFailure": "Помилка копіювання",
    "copySuccess": "Успішне копіювання",
    "Claimreward": "Отримати винагороду",
    "DailyLogin": "Щоденний вхід",
    "noInvitationsYet": "Ще немає запрошень",
    "LoadMore": "Завантажити більше",
    "WatchAD": "Дивитися рекламу",
    "continue": "Продовжити",
    "Congratulations": "Вітаємо",
    "MyFriends": "Мої друзі",
    "Invitefriends": "Запросити друзів",
    "Invitepremiumfriends": "Запросити преміум-друзів",
    "DailyTasks": "Щоденні завдання",
    "inviteDesc": "+{num} ${name} за кожного друга, якого ви запрошуєте",
    "DailyTasksDesc": "Виконуйте завдання, щоб отримати більше ${name}",
    "SponsorsandPartners": "Спонсори та партнери",
    "Receivingwallet": "Гаманець для отримання",
    "Enterwalletaddress": "Введіть адресу гаманця {name}",
    "Claim": "Отримати",
    "Booster": "Підсилювач",
    "RentPeriod": "Період оренди",
    "days30": "30 днів",
    "days": "днів",
    "Dailyprofit": "Щоденний прибуток",
    "Totalprofit": "Загальний прибуток",
    "Quantity": "Кількість",
    "RentPrice": "Ціна оренди",
    "RentMiner": "Орендувати Майнер",
    "Insufficient": "Недостатньо ${name}",
    "InsufficientMsg": "Потрібно {num} ${name1}, запросіть друзів або виконуйте завдання, щоб заробити більше ${name2}.",
    "Settings": "Налаштування",
    "copyid": "Скопіювати ID",
    "UpgradeSuccessfully": "Успішне оновлення",
    "Name": "Ім'я",
    "userinfo": "Інформація про користувача",
    "disconnect": "Відключитися",
    "Startmining": "Почати майнінг",
    "Welcome": "Ласкаво просимо до {name}",
    "Withdrawal": "Виведення",
    "Minimumamount": "Мінімальна сума",
    "Networkfee": "Комісія мережі",
    "Enteramount": "Введіть суму",
    "Submit": "Надіслати",
    "MinimumTip": "Сума виводу занадто мала. Мінімальна сума виводу: {num}",
    "MaximumTip": "Недостатня сума, максимальна сума, яку ви можете вивести: {num}",
    "SubmittedTip": "Надіслано, очікується обробка протягом 30-60 робочих днів",
    "WithdrawStatus": "Статус",
    "Submissiontime": "Час подання",
    "WithdrawAwaitTip": "* Оцінка часу 30-60 робочих днів. Запрошення більше друзів може прискорити процес перевірки.",
    "Processing": "Обробка",
    "Amount": "Сума",
    "Numberoffriends": "Кількість друзів: {now}/{limit}",
    "InviteTip": "Щоб здійснити перший вивід, вам потрібно запросити {limit} друзів приєднатися до майнінгового додатку.",
    "openonphone": "Відкрийте це посилання на своєму телефоні.",
    "claimTip": "Сума для отримання занадто мала. Мінімальна сума для отримання: {num}",
    "WalletBalance": "Баланс гаманця",
    "Withdraw": "Вивести",
    "SetWalletAddress": "Встановити адресу гаманця",
    "WithdrawalRecord": "Запис виводу",
    "Norecords": "Записів немає",
    "Whatis": "Що таке {name}?",
    "All": "Усе",
    "save": "Зберегти",
    "successWithdrawal": "Вивід отримано {num}",
    "secondsago": "{time} секунд тому",
    "Loading": "Завантаження...",
    "PaymentConfirming": "Перевірка статусу транзакції...",
    "Check": "Перевірити",
    "CheckFail": "Транзакцію не завершено. Будь ласка, перевірте знову через 5 секунд.",
    "Addname": "Додайте '{name}' до вашого імені",
    "Restattcheck": "Перезавантажте додаток для перевірки",
    "Copyname": "Скопіювати '{name}'",
    "SubmissionFailed": "Помилка при поданні, будь ласка, спробуйте ще раз пізніше",
    "WithdrawalReview": "Перевірка виводу",
    "WebWithdrawAwaitTip": "* Оцінка часу 24-48 годин. Запрошення більше друзів може прискорити процес перевірки.",
    "Success": "Успішно",
    "Rejection": "Відхилено",
    "WebSubmittedTip": "Надіслано, очікується обробка протягом 24-48 годин",
    "shop": "Магазин",
    "topurchase": "Перейти до магазину для покупки",
    "shopDesc": "Обмежена доступність—отримайте свій, поки не зник!",
    "claim": "Отримати",
    "payment_success": "Оплата успішна",
    "payment_failed": "Оплата не вдалася",
    "payment_cancelled": "Оплату скасовано",
    "opening_payment": "Відкриття платежу...",
    "payment_status": "Статус платежу",
    "create_order_failed": "Не вдалося створити замовлення",
    "creating_ton_order": "Створення замовлення TON...",
    "next_step": "Наступний крок",
    "use_ton_payment": "Використати платіж TON",
    "start_transaction": "Почати транзакцію",
    "connect_wallet": "Підключити гаманець",
    "address": "Адреса",
    "amount_ton": "Сума TON",
    "copy": "Копіювати",
    "amount": "Сума",
    "wallet_address": "Адреса гаманця",
    "comment_memo": "Коментар",
    "you_can_choose_to_connect_wallet_to_pay": "Ви можете вибрати підключення гаманця для оплати",
    "or_manually_transfer_to_the_above_address": "Або вручну перевести на вказану вище адресу (зверніть увагу, що сума та коментар мають бути точно такими ж)",
    "transaction_success": "Транзакція успішна",
    "transaction_failed": "Транзакція не вдалася",
    "transaction_error": "Помилка транзакції",
    "transaction_status": "Статус транзакції",
    "transaction_id": "ID транзакції",
    "transaction_amount": "Сума транзакції",
    "transaction_status_desc": "Опис статусу транзакції",
    "payment_status_tip": "Будь ласка, дочекайтеся підтвердження платежу",
    "select_payment_method": "Виберіть метод оплати",
    "total_amount": "Загальна сума",
    "creating_order": "Створення замовлення...",
    "order_created": "Замовлення створено",
    "order_status": "Статус замовлення",
    "Applyforwithdrawal": "Подати заявку на виведення",
    "Withdrawalunlock": "Розблокування виведення",
    "WithdrawalunlockTip": "Вам потрібно {num} запрошених друзів, щоб виконати завдання/прив'язати гаманці для розблокування виведення",
    "Close": "Закрити",
    "Delivering": "Доставка",
    "Duetothelargenumber": "Через велику кількість одержувачів, ваш аірдроп очікується протягом 15-20 робочих днів",
    "select_network": "Виберіть мережу",
    "confirm": "підтвердити",
    "switching_network": "Переключення мережі...",
    "network_switched": "Мережа перемкнена",
    "use_usdt_payment": "Використовуйте платіж USDT",
    "or_manually_transfer_to_the_above_address_usdt": "Переведіть вручну на вказану адресу (пам'ятайте, що сума та адреса повинні бути точно такими ж)",
    "chain_type": "Мережа",
    "check_transaction_status": "Перевірити статус транзакції",
    "transaction_wait": "Транзакція обробляється. Ви можете вийти з програми. Повідомлення сповістить вас, коли вона буде завершена.",
    "twa_pay_tip_with_memo": "Будь ласка, переконайтеся, що адреса, сума та примітка є послідовними для переказу.",
    "twa_pay_tip": "Будь ласка, переконайтеся, що адреса та сума правильні для переказу.",
    "creating_usdt_order": "Створення замовлення USDT...",
    "affiliate_programs": "Партнерські програми",
    "affiliate_programs_description": "Запрошуйте друзів приєднатися до програми видобутку та отримуйте винагороди.",
    "commission_details": "Деталі комісії",
    "no_commission_records": "Записів комісії немає",
    "commission_list": "Список комісій",
    "input_amount": "Введіть суму",
    "max": "Максимум",
    "commission_input_amount": "Введіть суму комісії",
    "min_commission": "Мінімальна сума для виведення складає {num}",
    "WithdrawalSuccess": "Виведення успішне",
    "WithdrawalFailed": "Виведення не вдалося",
    "WithdrawalProcessing": "Виведення в обробці",
    "award": "Нагорода",
    "level": "Рівень",
    "Share_to_group": "Поділитися в групі",
    "Exchange": "Обмін",
    "balance_not_enough": "Недостатньо балансу, ви можете обміняти лише {num} {coin}",
    "exchange_fail": "Обмін не вдалося здійснити",
    "exchange_success": "Обмін успішно завершено",
    "you_will_receive": "Ви отримаєте",
    "ShareToGroups": "Поділитися в групах",
    "Numberofgroups": "Кількість груп: {now}/{limit}",
    "Confirm": "Підтвердити",
    "ShareToGroupsDesc": "Поділіться в групах, щоб отримати більше {name}",
    "TokenAddress": "Будь ласка, введіть деталі виведення, такі як ID обміну або адресу USDT",
    "CashAddress": "Будь ласка, введіть деталі виведення, такі як номер банківської картки або адресу USDT",
    "Cancel": "Скасувати",
    "min_withdrawal_amount": "Мінімальна сума зняття становить {num} {coin}",
    "max_withdrawal_amount": "Максимальна сума зняття становить {num} {coin}",
    "withdrawal_failed": "Зняття не вдалося",
    "withdrawal_success": "Виведення успішне",
    "PayNow": "Оплатити зараз",
    "PaySkip": "Сплатіть {num}, щоб миттєво розблокувати виведення",
    "NumberofGroups": "Кількість груп: {now}/{limit}",
    "SendMessage": "Надіслати повідомлення",
    "NumberofShares": "Кількість акцій: {now}/{limit}",
    "NumberofTasks": "Кількість завдань: {now}/{limit}",
    "CompleteTask": "Завершити завдання",
    "PleaseEnterValidAmount": "Будь ласка, введіть дійсну суму",
    "PleaseEnterValidEmail": "Будь ласка, введіть дійсну електронну пошту",
    "Feedback": "Відгук",
    "Inputfeedbackcontent": "Введіть зміст відгуку",
    "Submitfeedback": "Надіслати відгук",
    "Pleaseenteravalidemailaddress": "Будь ласка, введіть дійсну адресу електронної пошти",
    "Pleaseenteryouremailaddress": "Будь ласка, введіть вашу адресу електронної пошти",
    "Youhavealreadyfeedbackedtoday_pleasecomebacktomorrow": "Ви вже залишили відгук сьогодні, будь ласка, поверніться завтра",
    "Feedback_submitted_successfully_thank_you_for_your_valuable_feedback": "Відгук успішно надіслано, дякуємо за ваш цінний відгук",
    "Feedback_submission_failed_please_retry": "Не вдалося надіслати відгук, будь ласка, спробуйте ще раз",
    "ContactUs": "Зв'яжіться з нами",
    "XRPAddress": "Будь ласка, введіть адресу гаманця XRP chain (включаючи MEMO), в іншому випадку ви не зможете вивести гроші.",
    "Accelerated": "Прискорено",
    "Accelerated_withdrawals_success": "Прискорені виведення успішно",
    "login": "Увійти",
    "register": "Зареєструватися",
    "login_with_google": "Увійти з Google",
    "or": "АБО",
    "email": "Електронна пошта",
    "password": "Пароль",
    "no_account": "Немає облікового запису",
    "click_to_go": "Натисніть, щоб",
    "have_account": "Вже є обліковий запис",
    "go_to": "Перейти до",
    "invite_code": "Запрошувальний код",
    "optional": "Необов'язково",
    "google_login_not_ready": "Увійти через Google поки що неможливо, будь ласка, спробуйте пізніше",
    "password_too_long": "Пароль занадто довгий",
    "weak": "Слабкий",
    "medium": "Середній",
    "strong": "Сильний",
    "login_success": "Увійшли успішно",
    "login_failed": "Не вдалося увійти",
    "please_input_email": "Будь ласка, введіть вашу електронну пошту",
    "invalid_email": "Неправильний формат електронної пошти",
    "please_input_password": "Будь ласка, введіть ваш пароль",
    "password_length_6_to_16": "Пароль має бути від 6 до 16 символів",
    "account_or_password_error": "Помилка облікового запису або пароля",
    "register_success": "Реєстрація успішна",
    "register_failed": "Не вдалося зареєструватися",
    "save_error": "Помилка збереження, будь ласка, спробуйте ще раз пізніше",
    "ShareToFriends": "Поділитися з друзями",
    "login_first": "Будь ласка, увійдіть спочатку",
    "WalletBscError": "❌ Неправильна адреса гаманця BNB Chain.",
    "DownloadWallet": "Завантажити гаманець",
    "AddToHomeScreen": "Додати {appName} на домашній екран",
    "TapShareInToolbar": "Натисніть на панелі інструментів",
    "SelectAddToHomeScreen": "Виберіть \"додати на домашній екран\"",
    "OpenToolbar": "Відкрити панель інструментів",
    "ClaimFailed": "Не вдалося отримати нагороду, будь ласка, спробуйте повторити пізніше",
    "guest_login": "Вхід для гостей",
    "please_input_phone": "Будь ласка, введіть ваш номер телефону",
    "email_error_1": "Будь ласка, введіть вашу електронну пошту",
    "email_error_2": "Будь ласка, введіть дійсну електронну адресу",
    "email_error_3": "Електронна пошта гостей не допускається, будь ласка, використовуйте реальну електронну пошту",
    "phone": "Телефон",
    "phone_error_1": "Будь ласка, введіть ваш номер телефону",
    "phone_error_2": "Будь ласка, введіть дійсний номер телефону",
    "update_info": "Оновити інформацію",
    "update_success": "Оновлення успішне",
    "update_failed": "Не вдалося оновити, будь ласка, спробуйте ще раз пізніше",
    "cancel": "Скасувати",
    "guest_credentials_title": "Інформація про рахунок",
    "guest_credentials_warning": "Будь ласка, зробіть скріншот, щоб зберегти ваш рахунок та пароль. Якщо ви їх втратите, ваші заробітки не можуть бути відновлені!",
    "i_have_saved": "Я зберіг",
    "account": "Рахунок",
    "view_credentials": "Переглянути облікові дані",
    "miner_max_reached": "Ви досягли максимальної кількості цього майнера"
}};